<template>
  <div>
    <PageHeader :title="`RLS対象一覧`" class="list">
      <template #title-header-content>
        <div class="flex-1 pl-2 flex ml-2 justify-end items-center">

          <div class="bg-white flex text-white font-bold text-sm p-2 rounded mx-auto w-fit">
            <div class="w-28 rounded py-1 text-center cursor-pointer mr-2" :class="filter.title==1?'bg-blue-700':'bg-gray-400'" @click="clickTitle(1)">物件ごと</div>
            <div class="w-28 rounded py-1 text-center cursor-pointer mr-2" :class="filter.title==2?'bg-blue-700':'bg-gray-400'" @click="clickTitle(2)">スタッフごと</div>
            <!-- <div class="w-28 rounded py-1 text-center cursor-pointer mr-2" :class="filter.title==3?'bg-blue-700':'bg-gray-400'" @click="clickTitle(3)">一括変更</div> -->
          </div>

          <div v-if="admin" v-tooltip="'管理者権限のみ可能'">
            <PrimaryButton
              text="1ヶ月分の予定を生成"
              size="xs"
              :buttonContents="'要'"
              class="bg-blue-500"
              @click="generateRlsModalOpen=true"
            >
            </PrimaryButton>
          </div>

          <h1 v-if="filter.title!=2" class="text-lg font-bold text-white ml-5">
            {{ records }} 件
          </h1>

          <Icon
            iconName="Refresh"
            :clickable="false"
            :class="{'animate-spin': loading}"
            class="text-white hover:text-gray-300 active:text-gray-400 ml-4 cursor-pointer"
            @click.native="getData(1)"
          />
        </div>
      </template>
      <template #page-header-content>
        <div class="pl-4 flex items-center">
          <!-- 凡例と固定休（物件ごとタブだけ）。左端 -->
          <div v-if="filter.title === 1" class="legend">
            <div class="legend-item"><span class="legend-mark" style="background: #fef3c7; border-color: #f59e0b"></span>未保存の行</div>
            <div class="legend-item"><span class="legend-mark" style="background: #d1fae5; border-color: #10b981"></span>ゴミ出し</div>
            <div class="legend-item"><span class="legend-mark" style="background: #ede9fe; border-color: #8b5cf6"></span>清掃</div>
            <div class="legend-link" @click="showHolidayPanel = !showHolidayPanel">{{ showHolidayPanel ? '固定休を閉じる' : 'スタッフの固定休' }}</div>
          </div>

          <!-- 絞り込み。右端 -->
          <div class="flex items-center ml-auto">
          <!-- 設定値 -->
          <select
            v-if="filter.title === 1"
            v-model="filter.status"
            class="border-gray-300 text-sm rounded mr-2"
          >
            <option
              v-for="row in [{ key: 0, val: '設定 未・済（全て）' },{ key: 1, val: '未設定' },{ key: 2, val: '設定済み' }]" :key="'s'+row.key"
              :value="row.key"
              class="bg-white">
              {{ row.val }}
            </option>
          </select>

          <!-- 得意先名 -->
          <div v-if="filter.title === 1" class="mr-2">
            <input
              type="search"
              name="filterClient"
              placeholder="得意先名 検索"
              class="w-full py-2 pr-3 border border-gray-300 rounded-md leading-5 focus:bg-white focus:ring-white focus:placeholder-gray-500 focus:text-gray-900"
              v-model="filter.client"
            />
          </div>

          <!-- 物件名 -->
          <div v-if="filter.title === 1" class="mr-2">
            <input
              v-tooltip="'記号・スペースは無視、大文字/小文字・数値/漢数字どちらも検索'"
              type="search"
              name="filterSite"
              placeholder="物件名・カナ 検索"
              class="w-full py-2 pr-3 border border-gray-300 rounded-md leading-5 focus:bg-white focus:ring-white focus:placeholder-gray-500 focus:text-gray-900"
              v-model="filter.site"
            />
          </div>

          <!-- 担当者 -->
          <div class="mr-2">
            <WmsSuggestInput
              :selectionItems="staffList"
              displayField="userName"
              :embed="true"
              :clearable="true"
              placeholder="スタッフ 検索"
              class="staff-filter"
              v-model="filter.staff"
            >
            </WmsSuggestInput>
          </div>

          <PrimaryButton
            text=" 検索 "
            :buttonContents="'要'"
            class="ml-5 w-32"
            @click="getData(1)"
          >
          </PrimaryButton>
          </div>
        </div>
        <div class="text-transparent text-xs">{{reload}}</div>
      </template>
    </PageHeader>

    <main class="absolute top-32 w-screen bottom-4 -mt-2">
      <div class="mx-auto px-2 sm:px-4 lg:px-8 h-full">
        <div class="bg-white rounded-md border border-gray-200 overflow-auto h-full">

          <div v-if="loading" class="main flex justify-center items-center">
            <p class="text-gray-400 font-bold">Searching...</p>
          </div>

          <!-- ************************************************** -->
          <!-- ********************* 物件 *********************** -->
          <!-- ************************************************** -->
          <div v-else-if="filter.title==1" class="max-table mst-bg">
            <div v-if="list&&list.length" class="h-full w-full px-4 py-3 flex flex-col">
              <!-- 使い方 -->
              <div class="text-xs text-gray-600 mb-2">
                <span v-if="canEdit">欄を押すとその場で直せます。直した行は黄色になるので、行の「保存」を押してください（保存するとその物件の予定を作り直します）。</span>
                <span v-else>マスタの変更は管理者・4グループ以上・事務センター・人事総務経理だけ可能です。</span>
              </div>

              <!-- スタッフの固定休 -->
              <div v-if="showHolidayPanel" class="flex flex-wrap gap-3 mb-3 text-xs">
                <div v-for="(hw, k) in holidayWeeks" :key="'hw'+k" class="border border-gray-200 rounded-lg bg-white p-2">
                  <div class="font-bold text-gray-700 mb-1">{{ hw.name }}曜日が固定休</div>
                  <div class="flex flex-wrap gap-1">
                    <span v-for="(s, j) in hw.staffs" :key="'hws'+k+j" class="px-2 py-0.5 rounded bg-gray-100">{{ s }}</span>
                  </div>
                </div>
                <div v-if="!Object.keys(holidayWeeks).length" class="text-gray-500">固定休のあるスタッフはいません</div>
              </div>

              <!-- リスト（1 物件＝1 tbody。行の中で直して保存）。カードが縦横のスクロールの箱。見出しは上に固定 -->
              <div class="mst-card flex-1 min-h-0 overflow-auto">
              <table class="text-sm w-full mst-table">
                <thead class="sticky top-0 z-20 whitespace-nowrap">
                  <tr>
                    <th v-for="(c, i) in columns" :key="'col'+i" :class="c.class">
                      {{ c.val }}
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <RlsMstRow
                  v-for="row in list"
                  :key="row.siteCode + '_' + (row.startDate || '')"
                  :row="row"
                  :staffList="staffList"
                  :editable="canEdit"
                  :preset="preset && preset.siteCode === row.siteCode ? preset : null"
                  :special="specialMap[row.siteCode] || null"
                  @special="onSpecial"
                  @dirty="onDirty"
                  @saved="preset = null"
                  @reload="getData()"
                  @outline="openOutline"
                  @calendar="openCalendar"
                />
              </table>
              </div>
            </div>
            <div v-else class="h-full flex justify-center items-center">
              <p class="text-gray-400 font-bold">対象データがありません</p>
            </div>
          </div>

          <!-- ************************************************** -->
          <!-- ******************* スタッフ ********************* -->
          <!-- ************************************************** -->
          <div v-else-if="filter.title==2" class="flex max-table w-full">
            <!-- スタッフ絞り込み -->
            <div class="h-full border-2 border-teal-500 text-white font-bold flex">
              <div v-if="filter.openBar" class="h-full overflow-y-auto overflow-x-hidden py-2 text-xs">
                <div class="flex justify-between">
                  <!-- クリア -->
                  <div class="border-b-2 border-indigo-700 text-indigo-700 m-3 px-2 w-fit cursor-pointer text-base font-extrabold self-baseline" @click="clickClear()">クリア</div>

                  <PrimaryButton
                    text="検索"
                    :buttonContents="'要'"
                    class="m-3 w-1/2"
                    @click="getData(1)"
                  >
                  </PrimaryButton>
                </div>

                <div v-if="group>1" class="flex">
                  <!-- 直属の部下 -->
                  <div class="flex-1 text-center border-b-2 border-indigo-700 text-indigo-700 m-3 w-fit cursor-pointer text-base font-extrabold whitespace-nowrap" @click="clickJunior()">直属の部下</div>
                  <!-- 部下全員 -->
                  <div v-if="group>2" class="flex-1 text-center border-b-2 border-indigo-700 text-indigo-700 m-3 w-fit cursor-pointer text-base font-extrabold whitespace-nowrap" @click="clickJunior('all')">部下全員</div>
                </div>

                <!-- 部下全員 -->
                <div class="rounded m-2 px-3 py-2 whitespace-nowrap border border-teal-500 text-center cursor-pointer" :class="filter.allStaff?'bg-teal-600':'bg-gray-500'" @click="clickAllStaff()">全員表示</div>

                <div class="staff-grid mx-2">
                  <div  class="rounded px-2 py-1 cursor-pointer" :class="filter.allStaff||filter.staffList.includes(null)?'bg-teal-600':'bg-gray-500'" @click="clickStaff(null)">未定</div>
                  <div v-for="(s, i) in staffList" :key="'staffs'+i" class="rounded px-2 py-1 whitespace-nowrap cursor-pointer" :class="[filter.allStaff||filter.staffList.includes(s.userId)?'bg-teal-600':'bg-gray-500', s.userId==userId?'border-2 border-yellow-500':'']" @click="clickStaff(s.userId)">
                    {{ s.userName }}
                  </div>
                </div>
              </div>
              <!-- 開閉バー -->
              <div class="h-full border-teal-500 bg-teal-500 text-white px-1.5 py-10 font-bold bar cursor-pointer" @click="clickBar()">
                <div v-if="filter.openBar">
                  スタッフ 検索 &#12288; ◀ ◀ ◀
                </div>
                <div v-else>
                  スタッフ 検索 &#12288; ▶ ▶ ▶
                </div>
              </div>
            </div>
            <div v-if="list&&list.length" class="h-full w-full overflow-auto border">
              <!-- リスト -->
              <table class="text-sm w-full">
                <thead class="sticky top-0 z-20 bg-colu whitespace-nowrap">
                  <tr>
                    <th v-for="(c, i) in columns" :key="'col'+i" class="p-2" :class="c.class">
                      {{ c.val }}
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in list" :key="'lit'+i" class="border-b hover-color whitespace-nowrap">

                    <!-- スタッフ -->
                    <td class="whitespace-nowrap p-2 border-separate sticky left-0 bg-white border-b-2 border-gray-400 text-center z-10">
                      <p class="font-bold">{{ row.staff }}</p>
                      <p class="text-xs font-bold text-gray-500 pt-3 pb-1">（公休日）</p>
                      <p>{{ row.holidayWeeksSt || '-' }}</p>
                    </td>

                    <td v-for="(w, j) in weekList" :key="'lit'+i+'key'+j" class="border-l border-b-2 border-gray-400 align-top py-2">
                      <!-- 曜日ごと -->
                      <div class="font-bold flex justify-center text-xs">

                        <!-- ゴミ -->
                        <div class="mx-1">
                          <div v-if="row['trash' + w.key]&&row['trash' + w.key].length">
                            <div class="text-sm text-center">ゴミ {{ row['trash' + w.key].length }} 件</div>
                            <div v-for="(t, k) in row['trash' + w.key]" :key="'lit'+i+'key'+j+'t'+k" @click="edit({ siteCode: t.site_code, site: t.site })" class="bg-green-800 text-white p-1 my-1 mx-2 rounded whitespace-nowrap cursor-pointer">
                              {{ t.site }}
                              <p v-if="t.work!='毎週'" class="pt-1 text-yellow-200">{{ t.work }}</p>
                            </div>
                          </div>

                          <!-- 物件追加 -->
                          <div v-if="row.staffId">
                            <WmsSuggestInput
                              :selectionItems="siteList"
                              :displayField="['site', 'client']"
                              :embed="true"
                              :clearable="true"
                              placeholder="ゴミ出し物件を追加"
                              class="add-site"
                              @selected="selectedSite(row, 'trash', w.key, $event)"
                            >
                            </WmsSuggestInput>
                          </div>
                        </div>

                        <!-- 清掃 -->
                        <div class="mx-1">
                          <div v-if="row['clean' + w.key]&&row['clean' + w.key].length">
                            <div class="text-sm text-center">清掃 {{ row['clean' + w.key].length }} 件</div>
                            <div v-for="(c, k) in row['clean' + w.key]" :key="'lit'+i+'key'+j+'c'+k" @click="edit({ siteCode: c.site_code, site: c.site })" class="bg-blue-800 text-white p-1 my-1 mx-2 rounded whitespace-nowrap cursor-pointer">
                              {{ c.site }}
                                <p v-if="c.work!='毎週'" class="pt-1 text-yellow-200">{{ c.work }}</p>
                            </div>
                          </div>

                          <!-- 物件追加 -->
                          <div v-if="row.staffId">
                            <WmsSuggestInput
                              :selectionItems="siteList"
                              :displayField="['site', 'client']"
                              :embed="true"
                              :clearable="true"
                              placeholder="清掃物件を追加"
                              class="add-site"
                              @selected="selectedSite(row, 'clean', w.key, $event)"
                            >
                            </WmsSuggestInput>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else class="w-full h-full flex justify-center items-center text-gray-400 font-bold">
              <div>
              <p>対象データがありません</p>
              <p v-if="!filter.allStaff&&!filter.staffList.length" class="text-red-700">左側の「スタッフ検索」にて「全員表示」もしくはスタッフを選択してください。</p>
              </div>
            </div>
          </div>

          <!-- ************************************************** -->
          <!-- ********************* 一括 *********************** -->
          <!-- ************************************************** -->
          <div v-else-if="filter.title==3" class="rounded h-full">
            <div class="text-red-700 font-bold text-center my-1 text-sm">※退職スタッフ名（退職予定含む）は「未定」にせず、そのまま表示しています</div>
            <div class="font-bold text-center text-gray-700">
              <p>
                <Icon iconName="Exclamation" class="text-yellow-600 inline" />
                変更適用開始日を入力してください（適用開始日は重要ですので間違いのないようお気を付けください）
              </p>
              <div class="flex justify-center items-end mt-1 mb-3">
                <WmsDateInput
                  v-model="startDate"
                  class="font-bold"
                  :class="!startDate?'emp-red':''"
                />
                <div>から適用開始</div>
              </div>
            </div>
            <div class="font-bold text-center text-blue-700 mb-2">下の表にて担当者を変更したいデータにチェックしてください</div>

            <table v-if="list&&list.length" class="w-full overflow-auto ">
              <thead class="sticky top-0 z-5 bg-colu text-xs text-gray-700">
                <tr>
                  <th v-for="(c, i) in columns" :key="'col'+i" class="p-2 text-gray-800" :class="c.class">
                    <div v-if="c.key=='check1'" class="rounded bg-indigo-600 text-white cursor-pointer p-1 w-fit whitespace-nowrap mx-auto" @click="changeAll(c.id)">
                      ✅ ゴミ担当者
                      <p>{{ filter.staff?`「${filter.staff}」のみ`:'' }}全選択</p>
                    </div>
                    <div v-else-if="c.key=='check2'" class="rounded bg-indigo-600 text-white cursor-pointer p-1 w-fit whitespace-nowrap mx-auto" @click="changeAll(c.id)">
                      ✅ 清掃担当者
                      <p>{{ filter.staff?`「${filter.staff}」のみ`:'' }}全選択</p>
                    </div>
                    <div v-else>
                      {{ c.val }}
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody class="text-sm">
                <tr class="border-b border-gray-400">
                  <td></td>
                  <td></td>
                  <td class="text-xs font-bold text-gray-700 border-l border-gray-400 p-1.5 w-fit whitespace-nowrap min-w-min text-center">担当を一括変更</td>
                  <td class="text-center p-1 ">
                    <div class="text-xs text-gray-700 p-1">担当者を選び、決定ボタンを押してください<br>チェックがついたものを変更します</div>
                    <div class="flex whitespace-nowrap justify-center">
                      <WmsSuggestInput
                        :selectionItems="staffList"
                        displayField="userName"
                        :embed="true"
                        :clearable="true"
                        class="w-32 staff"
                        v-model="allChangeStaffTrash"
                      >
                      </WmsSuggestInput>

                      <div class="text-xs font-bold self-center text-gray-700 ml-1 mr-2">に変更</div>

                      <PrimaryButton text="決定" size="sm" class="px-1 bg-blue-100 text-blue-700 border-blue-700" @click="clickChangeStaff('Trash')" :disabled="loading"></PrimaryButton>
                    </div>
                  </td>
                  <td class="text-xs font-bold text-gray-700 border-l border-gray-400 p-1.5 w-fit whitespace-nowrap min-w-min text-center">担当を一括変更</td>
                  <td class="text-center p-1 ">
                    <div class="text-xs text-gray-700 p-1">担当者を選び、決定ボタンを押してください<br>チェックがついたものを変更します</div>
                    <div class="flex whitespace-nowrap justify-center">
                      <WmsSuggestInput
                        :selectionItems="staffList"
                        displayField="userName"
                        :embed="true"
                        :clearable="true"
                        class="w-32 staff"
                        v-model="allChangeStaffClean"
                      >
                      </WmsSuggestInput>

                      <div class="text-xs font-bold self-center text-gray-700 ml-1 mr-2">に変更</div>

                      <PrimaryButton text="決定" size="sm" class="px-1 bg-blue-100 text-blue-700 border-blue-700" @click="clickChangeStaff('Clean')" :disabled="loading"></PrimaryButton>
                    </div>
                  </td>
                </tr>
                <tr v-for="(row, i) in list" :key="'lit'+i" class="border-b border-gray-400 hover-color">
                  <!-- 物件 -->
                  <td class="cursor-pointer font-bold whitespace-nowrap w-fit">
                    <div class="border-b text-blue-700 border-blue-700 w-fit m-2" @click="edit(row)">{{ row.site }}</div>
                    <div class="p-2 text-gray-700 font-normal">{{ row.address }}</div>
                  </td>

                  <!-- カレンダー -->
                  <td class="p-2 text-gray-700 font-bold whitespace-nowrap text-xs cursor-pointer" @click="openCalendar(row)">
                    <div class="border-b border-gray-700 w-fit">カレンダー</div>
                  </td>

                  <!-- 変更チェック -->
                  <td class="p-2 text-center border-l border-gray-400">
                    <input v-if="row.isTrash&&!row.trashDoneTime" type="checkbox" class="p-2" v-model="row.changeTrash">
                  </td>

                  <!-- ゴミ担当 -->
                  <td class="p-2 text-center whitespace-nowrap">
                    <!-- なし -->
                    <div v-if="!row.isTrash">--</div>
                    <!-- あり -->
                    <WmsSuggestInput
                      v-else-if="!row.trashDoneTime"
                      :selectionItems="staffList"
                      displayField="userName"
                      :embed="true"
                      :clearable="true"
                      v-model="row.trashStaff"
                      @selected="staffSelected(row, 'trash', $event)"
                      class="w-fit mx-auto staff"
                    >
                    </WmsSuggestInput>
                    <div v-else class="text-xs font-bold text-gray-700">
                      完了済
                    </div>
                    <!-- 変更フラグ -->
                    <div v-if="row.isChangedTrash&&!row.trashDoneTime" class="text-red-700 font-bold text-xs">変更済み</div>
                  </td>

                  <!-- 変更チェック -->
                  <td class="text-center w-fit border-l border-gray-400">
                    <input v-if="row.isClean&&!row.cleanDoneTime" type="checkbox" class="p-2" v-model="row.changeClean">
                  </td>

                  <!-- 清掃担当 -->
                  <td class="p-2 text-center whitespace-nowrap">
                    <div class="text-light-blue-500 text-sm" v-if="row.exchange">{{ row.exchange }}の振替</div>
                    <!-- なし -->
                    <div v-if="!row.isClean">--</div>
                    <!-- あり -->
                    <WmsSuggestInput
                      v-else-if="!row.cleanDoneTime"
                      :selectionItems="staffList"
                      displayField="userName"
                      :embed="true"
                      :clearable="true"
                      v-model="row.cleanStaff"
                      @selected="staffSelected(row, 'clean', $event)"
                      class="w-fit mx-auto staff"
                    >
                    </WmsSuggestInput>
                    <div v-else class="text-xs font-bold text-gray-700">
                      完了済
                    </div>
                    <!-- 変更フラグ -->
                    <div v-if="row.isChangedClean&&!row.cleanDoneTime" class="text-red-700 font-bold text-xs">変更済み</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div v-if="!loading&&list&&list.length" class="w-fit mx-auto mt-3">
            <pagination id="pagenation" v-model="page" :per-page="perPage" :records="records" class="text-center" @paginate="getData()" />
          </div>
        </div>

      </div>
    </main>

    <!-- 物件のカレンダー -->
    <RlsCalendarModal
      v-model="siteCalendarOpen"
      :target="siteCalendar"
      :open="siteCalendarOpen"
      @closed="closedCalendar"
    />
    <!-- 予定生成 -->
    <RlsScheduleGenerateModal
      v-model="generateRlsModalOpen"
      @closed="generateRlsModalOpen=false"
    />
  </div>
</template>

<script>
import Icon from '@components/Icon.vue'
import PageHeader from '@components/PageHeader.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import Pagination from 'vue-pagination-2'
import RlsMstRow from '../components/RlsMstRow.vue'
import RlsCalendarModal from '../components/RlsCalendarModal.vue'
import RlsScheduleGenerateModal from '../components/RlsScheduleGenerateModal.vue'
import WmsSuggestInput from '@wmscomponents/WmsSuggestInput.vue'
import WmsDateInput from '@wmscomponents/WmsDateInput.vue'
import * as dialogs from '@libs/dialogs'
import * as backend from '@libs/backend'
import * as utils from '@libs/utils'
import { WEEK_NUM, WEEK_NUM_TO_NAME } from '@libs/constants'

import PageModel from '../../main/pages/PageModel.vue'

const SETTION_STRAGE_NAME = 'rlsMstFilter'

const COL1 = [
        { key: 'site', val: '物件', class: 'text-left pl-4' },
        { key: 'months', val: '実施月', class: 'text-center' },
        { key: 'Mon', val: '月', class: 'text-center th-week' },
        { key: 'Tue', val: '火', class: 'text-center th-week' },
        { key: 'Wed', val: '水', class: 'text-center th-week' },
        { key: 'Thu', val: '木', class: 'text-center th-week' },
        { key: 'Fri', val: '金', class: 'text-center th-week' },
        { key: 'Sat', val: '土', class: 'text-center th-week' },
        { key: 'holiday', val: '祝日', class: 'text-center th-center' },
        { key: 'startDate', val: '適用開始日', class: 'text-center th-center' }
      ]

const COL2 = [
        { key: 'staff', val: 'スタッフ名', class: 'text-left' },
        { key: 'Mon', val: '月', class: 'text-center border-l border-dashed' },
        { key: 'Tue', val: '火', class: 'text-center border-l border-dashed' },
        { key: 'Wed', val: '水', class: 'text-center border-l border-dashed' },
        { key: 'Thu', val: '木', class: 'text-center border-l border-dashed' },
        { key: 'Fri', val: '金', class: 'text-center border-l border-dashed' },
        { key: 'Sat', val: '土', class: 'text-center border-l border-dashed' },
      ]

const COL3 = [
        { key: 'site', val: '物件名（クリックでマスタ表示）', class: 'text-left', rowspan: 2 },
        { key: 'Mon', val: '月', class: 'text-center border-l border-dashed' },
        { key: 'Tue', val: '火', class: 'text-center border-l border-dashed' },
        { key: 'Wed', val: '水', class: 'text-center border-l border-dashed' },
        { key: 'Thu', val: '木', class: 'text-center border-l border-dashed' },
        { key: 'Fri', val: '金', class: 'text-center border-l border-dashed' },
        { key: 'Sat', val: '土', class: 'text-center border-l border-dashed' },
      ]

export default {
  extends: PageModel,
  components: {
    Icon,
    PageHeader,
    PrimaryButton,
    Pagination,
    RlsMstRow,
    RlsCalendarModal,
    RlsScheduleGenerateModal,
    WmsSuggestInput,
    WmsDateInput
  },

  props: {
  },

  data() {
    return {
      loading: false,
      reload: 0,

       //検索
      filter: {
        title: 1,
        status: 0,
        site : '',
        client: '',
        staff: '',
        openBar: true,
        // 全員表示
        allStaff: false,
        // 担当者絞り込み
        staffList: [Number(this.$store.getters.user.id)],
        // 開始日
        startDate: null
      },
      // カラム
      columns: [],
      // 曜日カラム
      weekList: [
        { key: 'Mon', val: '月' },
        { key: 'Tue', val: '火' },
        { key: 'Wed', val: '水' },
        { key: 'Thu', val: '木' },
        { key: 'Fri', val: '金' },
        { key: 'Sat', val: '土' },
      ],
      // 表示するデータ
      list: [],
      // ページ数
      page: 1,
      // １ページの最大件数
      perPage: 50,
      // 全件数
      records: 0,

      // 未保存の行（キー：物件コード_適用開始日）
      dirtyRows: {},
      // スタッフごとタブから別タブで開いたときに最初に入れる担当（{ siteCode, type, week, staffId, staff }）
      preset: null,
      // スタッフの固定休の一覧を開いているか
      showHolidayPanel: false,
      // 特別仕様（物件コード → { siteCode, format, items }）
      specialMap: {},

      // 物件のカレンダー
      siteCalendarOpen: false,
      siteCalendar: null,

      // 予定生成ダイアログ
      generateRlsModalOpen: false,

      // 一括変更用の変更適用開始日
      startDate: null,

      // スタッフリスト
      staffList: [],
      // 直属の部下
      junior: [],
      // 部下全員
      allJunior: [],
      // 物件リスト
      siteList: []
    }
  },

  async created() {
    // 条件取得
    this.getCondition()
    // スタッフごとタブの「物件を追加」から別タブで開いたとき：その物件だけに絞り、選んだ曜日に担当を入れた状態で出す
    const q = this.$route.query
    if (q && q.siteCode) {
      this.filter.title = 1
      this.filter.status = 0
      this.filter.site = q.site || ''
      this.filter.client = ''
      this.filter.staff = ''
      if (q.type && q.week && q.staffId) {
        this.preset = { siteCode: q.siteCode, type: q.type, week: q.week, staffId: Number(q.staffId), staff: q.staff || '' }
      }
    }
    window.addEventListener('beforeunload', this.warnUnsaved)
    // 物件リスト
    this.getSite()
    // 特別仕様
    this.getSpecial()
    // スタッフリスト
    await this.getStaff()
    // スタッフリストにあるユーザーIDのみにする
    if (this.filter.staffList.length) {
      this.filter.staffList = this.staffList
        .map(s => s.userId)
        .filter(id => this.filter.staffList.includes(id))
    }
    // データ取得
    await this.getData()
  },

	computed: {
    admin() {
      // 管理者権限がある場合
      if (this.$store.getters.auth && this.$store.getters.auth.adminAuth) {
        return true
      }
      return false
    },

    userId() {
      return Number(this.$store.getters.user.id)
    },

    group() {
      let res = 0
      const g = this.$store.getters.loginUserData
      if (g && g.groupNum) {
        res = g.groupNum
      }
      return res
    },

    /**
     * マスタを直せるか（管理者・4グループ以上・事務センター・人事総務経理）
     */
    canEdit() {
      if (this.admin) {
        return true
      }
      if (this.group >= 4) {
        return true
      }
      const g = this.$store.getters.loginUserData
      if (g && g.departmentName && ['事務センター', '人事総務経理'].includes(g.departmentName)) {
        return true
      }
      return false
    },

    /**
     * 曜日ごとの固定休のスタッフ（日曜以外）
     */
    holidayWeeks() {
      const arr = {}
      for (const s of this.staffList) {
        if (!s.holidayWeeks || !s.holidayWeeks.length) {
          continue
        }
        for (const w of s.holidayWeeks) {
          if (w === 0) {
            continue
          }
          if (!arr[w]) {
            arr[w] = { name: WEEK_NUM_TO_NAME[w], staffs: [] }
          }
          arr[w].staffs.push(s.userName)
        }
      }
      return arr
    },

    /**
     * 未保存の行があるか
     */
    hasDirty() {
      return Object.keys(this.dirtyRows).length > 0
    }
	},

  /**
   * 未保存の行があれば画面を離れる前に確認
   */
  async beforeRouteLeave(to, from, next) {
    if (this.hasDirty) {
      const r = await dialogs.showConfirmDialog('確認', '保存していない変更があります。移動してよろしいですか？', 'はい', 'キャンセル')
      if (r !== 'YES') {
        next(false)
        return
      }
    }
    next()
  },

  beforeDestroy() {
    window.removeEventListener('beforeunload', this.warnUnsaved)
  },

  methods: {
    /**
     * ブラウザを閉じる・再読み込みのとき、未保存の行があれば確認（文言はブラウザのもの）
     */
    warnUnsaved(e) {
      if (this.hasDirty) {
        e.preventDefault()
        e.returnValue = ''
      }
    },

    /**
     * 行の未保存の状態を控える
     */
    onDirty(e) {
      const key = e.siteCode + '_' + (e.startDate || '')
      const rows = { ...this.dirtyRows }
      if (e.dirty) {
        rows[key] = true
      } else {
        delete rows[key]
      }
      this.dirtyRows = rows
    },

    /**
     * データ取得（未保存の行があれば確認してから取り直す）
     */
    async getData(num) {
      if (this.hasDirty) {
        const r = await dialogs.showConfirmDialog('確認', '保存していない変更があります。取り直すと変更は消えます。よろしいですか？', 'はい', 'キャンセル')
        if (r !== 'YES') {
          return
        }
      }
      this.dirtyRows = {}
      this.loading = true
      this.setSessionStorage()
      if (num) {
        this.page = num
      }

      // 物件ごと
      if (this.filter.title == 1) {
        this.perPage = 50
        this.columns = utils.clone(COL1)

      // スタッフごと
      } else if (this.filter.title == 2) {
        this.perPage = 10
        this.columns = utils.clone(COL2)
        if (!this.filter.allStaff && !this.filter.staffList.length) {
          this.list = []
          this.loading = false
          this.records = 0
          return
        }

      // 一括変更
      } else if (this.filter.title == 3) {
        this.columns = utils.clone(COL3)
      }

      const res = await backend.postData('rls/getRlsMst', { ...this.filter, perPage: this.perPage, page: this.page })
      this.list = res.data.data
      if (!this.list.length) {
        this.records = 0
      } else {
        this.records = Number(this.list[0].totalSize)
      }

      if (this.filter.title === 2) {
        this.list.forEach(row => row.holidayWeeksSt = this.getWeek(row.hw))
      }
      this.loading = false
    },

    /**
     * 公休日取得
     * @param tar
     */
    getWeek(tar) {
      const res = []
      if (tar && tar.length) {
        for (let i = 0; i < WEEK_NUM.length; i++) {
          const w = WEEK_NUM[i]
          if (tar.includes(w.value)) {
            res.push(w.text)
          }
        }
      }
      return res.join(' ・ ')
    },

    /**
     * 切り替え
     */
    clickTitle(title) {
      this.filter.title = title
      this.getData(1)
    },

    /**
     * 物件のマスタを別タブで開く（物件ごとタブをその物件だけに絞る）
     * @param siteCode 物件コード
     * @param site 物件名（絞り込みに使う）
     * @param preset 最初に入れる担当（{ type, week, staffId, staff }。無ければ絞るだけ）
     */
    openSiteTab(siteCode, site, preset) {
      const query = { siteCode, site: site || '' }
      if (preset) {
        query.type = preset.type
        query.week = preset.week
        query.staffId = preset.staffId
        query.staff = preset.staff
      }
      const resolved = this.$router.resolve({ name: 'RlsMaster', query })
      window.open(resolved.href, '_blank')
    },

    /**
     * スタッフごとタブの物件名を押した（その物件のマスタを別タブで開く）
     */
    edit(row) {
      const siteCode = row.siteCode || row.site_code
      const site = row.site || ''
      this.openSiteTab(siteCode, site.replace(/（.*$/, ''))
    },

    /**
     * 物件追加（スタッフごとタブ）。その物件のマスタを別タブで開き、選んだ曜日にその人を入れた状態で出す
     * @param row 対象スタッフデータ
     * @param type ゴミ出し・清掃
     * @param week 曜日
     * @param e 選択した物件データ
     */
    async selectedSite(row, type, week, e) {
      // すでに同じ物件を登録していないか
      const tar = row[type + week]

      // 対象の配列の中に、選択した物件がすでにあるか
      const exi = tar.some(site => site.site_code == e.code)
      if (exi) {
        const log = await dialogs.showWarningConfirmDialog(`${e.site} の担当は ${row.staff}さん`, `${e.site}は、既に ${row.staff} さんが担当していますが、進めますか？`)
        if (log != 'YES') {
          return
        }
      }

      this.openSiteTab(e.code, e.site, { type, week, staffId: row.staffId, staff: row.staff })
    },

    /**
     * 特別仕様の一覧（物件ごとの札と、その他の設定の初期値に使う）
     * API: rls/getSpecialList
     */
    async getSpecial() {
      const res = await backend.searchData('rls/getSpecialList')
      const map = {}
      if (res && res.data && res.data.data) {
        for (const s of res.data.data) {
          map[s.siteCode] = s
        }
      }
      this.specialMap = map
    },

    /**
     * 行で特別仕様を保存した
     */
    onSpecial(e) {
      const map = { ...this.specialMap }
      if (e.special) {
        map[e.siteCode] = e.special
      } else {
        delete map[e.siteCode]
      }
      this.specialMap = map
    },

    /**
     * 物件のカレンダーを開く
     */
    openCalendar(row) {
      this.siteCalendar = { siteCode: row.siteCode, site: row.site }
      this.siteCalendarOpen = true
    },

    /**
     * 物件のカレンダーを閉じる
     */
    closedCalendar() {
      this.siteCalendar = null
      this.siteCalendarOpen = false
    },

    /**
     * スタッフリスト取得
     */
    async getStaff() {
      const res = await backend.searchData('user/getByAuth', { auth: 'rls', departmentName: 'ラウンド', departmentName2: '品質管理', departmentName3: '建物管理' })
      if (res && res.data.data && res.data.data.length) {
        this.staffList = res.data.data
      }
    },

    /**
     * 物件リスト取得
     */
    async getSite() {
      const res = await backend.searchData('rls/getRlsSiteList')
      if (res && res.data.data && res.data.data.length) {
        this.siteList = res.data.data
      }
    },

    /**
     * 担当者検索欄バー開閉
     */
    clickBar() {
      this.filter.openBar = !this.filter.openBar
      this.reload++
    },

    /**
     * クリアボタン
     */
    clickClear() {
      this.filter.allStaff = false
      this.filter.staffList = []
      this.reload++
    },

    /**
     * 部下検索
     */
    async clickJunior(all) {
      if ((!all && this.junior && this.junior.length) || (all && this.allJunior && this.allJunior.length)) {
        if (all) {
          this.filter.staffList = utils.clone(this.allJunior)
        } else {
          this.filter.staffList = utils.clone(this.junior)
        }

      } else {
        const res = await backend.searchData('evaluation/getJunior', { all, userId: this.userId })
        if (res.data.data && res.data.data.length) {
          this.filter.staffList = res.data.data.map(row => row.userId)

          if (all) {
            this.allJunior = res.data.data.map(row => row.userId)
          } else {
            this.junior = res.data.data.map(row => row.userId)
          }
        }
      }

      this.filter.staffList.push(this.userId)
      this.reload++
    },

    /**
     * 全員表示
     */
    clickAllStaff() {
      this.filter.allStaff = !this.filter.allStaff
      // ONにした場合
      this.filter.staffList = this.staffList.map((s) => s.userId)
      this.filter.staffList.push(null)
      this.reload++
    },

    /**
     * スタッフ名クリック
     * @param userId ユーザーID
     */
    clickStaff(userId) {
      if (this.filter.staffList.includes(userId)) {
        this.filter.staffList = this.filter.staffList.filter((s) => {
          return s != userId
        })
        this.filter.allStaff = false

      } else {
        this.filter.staffList.push(userId)
      }
      this.reload++
    },

    /**
     * 物件概要書開く
     */
    openOutline(siteCode) {
      const resolvedRoute = this.$router.resolve({
        name: 'SiteOutlineEdit',
        query: {
          siteCode
        }
      })
      window.open(resolvedRoute.href, '_blank')
    },

    /**
     *  条件取得
     */
    getCondition(){
      const searchJson = sessionStorage.getItem(SETTION_STRAGE_NAME)
      const getItem = JSON.parse(searchJson)

      if(getItem){
        this.filter = getItem
      }
      if (this.filter.openBar == undefined) {
        this.filter.openBar = true
      }
      if (this.filter.client == undefined) {
        this.filter.client = ''
      }
      if (!this.filter.staffList || !this.filter.staffList.length) {
        this.filter.staffList = [Number(this.$store.getters.user.id)]
      }
    },

    /**
     * 検索条件をセッションストレージへ保存
     */
    setSessionStorage() {
      // 別タブで 1 物件に絞って開いたときの条件は控えない（次に普通に開いたとき絞られたままにならないように）
      if (this.$route.query && this.$route.query.siteCode) {
        return
      }
      const searchStr = JSON.stringify(this.filter)
      sessionStorage.setItem(SETTION_STRAGE_NAME, searchStr)
      if (!this.filter.title) {
        this.filter.title = 1
      }
    },
  },
}
</script>
<style scoped>

.main {
  height: calc(100% - 67px);
  /* min-width: 980px; */
}

.max-table {
  height: calc(100% - 60px);
  /* overflow: auto; */
}

.bar {
  writing-mode: vertical-rl
}

.staff-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 2列 */
  gap: 8px; /* 行・列の間隔 */
}

.hover-color:hover {
  background: rgba(184, 244, 242, 0.67);
}

/* 物件ごと：カードに載せた表 */
.mst-bg {
  background: #f4f6fa;
}

.mst-card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
}

.mst-table {
  border-collapse: separate;
  border-spacing: 0;
}

/* 見出しはネイビーで上に固定 */
.mst-table >>> thead th {
  position: sticky;
  top: 0;
  z-index: 20;
  background: #1e3a8a;
  color: #ffffff;
  font-size: 13px;
  font-weight: 700;
  padding: 12px 8px;
  border-bottom: 2px solid #172554;
}

.mst-table >>> thead th.th-week {
  border-left: 1px solid rgba(255, 255, 255, 0.18);
}

.mst-table >>> thead th.th-center {
  text-align: center !important;
}

/* 凡例 */
.legend {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-right: 16px;
  font-size: 12px;
  color: #e0e7ff;
  white-space: nowrap;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 5px;
}

.legend-mark {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 3px;
  border: 1px solid;
}

.legend-link {
  font-weight: 700;
  color: #ffffff;
  border-bottom: 1px solid #ffffff;
  cursor: pointer;
}

.add-site >>> input[type=text] {
  border-color: rgb(146, 145, 145) !important;
}

.staff-filter >>> input {
  height: 38px;
  min-width: 100px;
}

.emp-red >>> input {
  background: rgb(247, 182, 182);
}

 /* ページネーション */
#pagenation >>> ul {
  display: flex !important;
  color: rgb(6, 125, 194);
  font-weight: bold !important;
  cursor: pointer;
}

#pagenation >>> ul > li {
  padding: 0 10px;
}

#pagenation >>> ul > .active {
  background: rgb(6, 125, 194);
  color: white;
}

#pagenation >>> p {
  color: gray;
  font-size: small;
}
</style>